export default "__VITE_ASSET__BCAgarVc__"